import React from "react";

export const DataIntegrationDetailContext = React.createContext(null);

export const useDataIntegrationDetailContext = () => {
  const context = React.useContext(DataIntegrationDetailContext);

  if (!context)
    throw new Error("Data Integration Detail Context not provided!");

  return context;
};
